import { Star } from "lucide-react";

export const StarRating = ({ value = 0, size = "w-4 h-4", showValue = false, count }) => {
  const rounded = Math.round(value * 2) / 2;
  return (
    <span className="inline-flex items-center gap-1" data-testid="star-rating">
      <span className="inline-flex">
        {[1, 2, 3, 4, 5].map((i) => {
          const filled = i <= Math.floor(rounded);
          const half = !filled && i - 0.5 === rounded;
          return (
            <span key={i} className="relative">
              <Star className={`${size} text-[#DDD7CF]`} />
              {(filled || half) && (
                <Star
                  className={`${size} text-[#D4B36A] fill-[#D4B36A] absolute inset-0`}
                  style={half ? { clipPath: "inset(0 50% 0 0)" } : undefined}
                />
              )}
            </span>
          );
        })}
      </span>
      {showValue && value > 0 && (
        <span className="text-xs font-semibold text-[#6E675F]">
          {value.toFixed(1)}{typeof count === "number" ? ` (${count})` : ""}
        </span>
      )}
    </span>
  );
};

export const StarInput = ({ value, onChange }) => (
  <div className="inline-flex gap-1" data-testid="star-input">
    {[1, 2, 3, 4, 5].map((i) => (
      <button
        key={i}
        type="button"
        data-testid={`star-input-${i}`}
        onClick={() => onChange(i)}
        aria-label={`${i} star${i > 1 ? "s" : ""}`}
        className="transition-transform hover:scale-110"
      >
        <Star className={`w-7 h-7 ${i <= value ? "text-[#D4B36A] fill-[#D4B36A]" : "text-[#DDD7CF]"}`} />
      </button>
    ))}
  </div>
);
